import React from "react";
import { Box, Button, InputBase, IconButton } from "@mui/material";
import { SearchOutlined, AddCircleOutlineOutlined } from "@mui/icons-material";

type BookingType =
  | "CHURCH"
  | "FUNERAL"
  | "FUNERAL_HOME"
  | "OTHER"
  | "CONFERENCE"
  | "EVENT";

interface StreamListHeaderProps {
  bookingType: BookingType;
  inputValue: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSearch: () => void;
  onAddBooking: () => void;
  hasAddPermission?: boolean;
}

const BUTTON_LABELS: Record<BookingType, string> = {
  CHURCH: "Church",
  FUNERAL: "Funeral",
  FUNERAL_HOME: "Funeral Home",
  CONFERENCE: "Conference",
  EVENT: "Event",
  OTHER: "Booking",
};

const StreamListHeader: React.FC<StreamListHeaderProps> = ({
  bookingType,
  inputValue,
  onInputChange,
  onKeyDown,
  onSearch,
  onAddBooking,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "background.paper",
            px: 1,
            borderRadius: "4px", // Added for cleaner UI
          }}
        >
          <InputBase
            placeholder="Search..."
            value={inputValue}
            onChange={onInputChange}
            onKeyDown={onKeyDown}
            sx={{
              flex: 1,
              fontSize: "14px",
              minWidth: "300px",
            }}
          />
          <IconButton size="small" onClick={onSearch}>
            <SearchOutlined sx={{ fontSize: "20px", color: "text.secondary" }} />
          </IconButton>
        </Box>
      </Box>

      <Button
        variant="contained"
        startIcon={<AddCircleOutlineOutlined />}
        onClick={onAddBooking}
        sx={{
          backgroundColor: "#614438",
          color: "#fff",
          textTransform: "none",
          fontWeight: 500,
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: "#aa7b67",
          },
        }}
      >
        Add {BUTTON_LABELS[bookingType]} Booking
      </Button>
    </Box>
  );
};

export default StreamListHeader;
